import React from 'react';
import { Notification } from '@vds/notifications';
import {connect} from 'react-redux'
import { setError } from 'pages/Mobility/ducks/MobilitySlice';

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true, error };
    }
  
    componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
      // this.props.postError({error, errorInfo})
      // this.props.postUIEventLog({ eventType: 'error', eventName: "Error", message: `${error.toString()}, ${JSON.stringify(errorInfo.componentStack)}, - ${JSON.stringify(this.state.error)}`});
    }
    componentWillUnmount(){
      this.props.hideErrorOnPageChange()
    }
    render() {
      if (this.state.hasError ) {
        // You can render any custom fallback UI
        return 	<Notification
        type="error">
           Something went wrong. Please try again <a onClick={()=> this.props?.history?.replace({ pathname: "/", state: { prevPage: '/' } })}>  Start again</a>.
      </Notification>;
      }
      const isVBC = (!!this.props.sessionCart && !!this.props.sessionCart?.apiResponse && !!this.props.sessionCart?.apiResponse?.prospectFlowData && 
        !!this.props.sessionCart?.apiResponse?.prospectFlowData?.cart && !!this.props.sessionCart?.apiResponse?.prospectFlowData?.cart?.groupPackages)  ? 
        Object.values(this.props.sessionCart?.apiResponse?.prospectFlowData?.cart?.groupPackages).find(data=>data['groupPackageType'] === 'RENTAL_REGULAR') : undefined
      
        return(
        <>
        {(this.props.isError && !isVBC && !this.props?.isPlansFirst) ?
        <Notification type="error">Something went wrong. Please refresh the page.</Notification> : <></>}
        {this.props.children}
        </>
      ); 
    }
  }
  const mpaStateToProps = state =>({
    isError : state.MobilityPage.apiFail,
    sessionCart: state.GlobalData.sessionCartData
  })
  const mapDispatchtoProps = dispatch =>{
    return{
    hideErrorOnPageChange : ()=>dispatch(setError(false))
    }
  }
  export default connect(mpaStateToProps,mapDispatchtoProps)(ErrorBoundary);